import { render, staticRenderFns } from "./MessageReplyField.vue?vue&type=template&id=6581fb8d&scoped=true&"
import script from "./MessageReplyField.vue?vue&type=script&lang=js&"
export * from "./MessageReplyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581fb8d",
  null
  
)

export default component.exports